export enum UserRole {
    Driver = 0,
    ServiceProvider = 1,
    Forwarder = 2,
    Client = 3,
    Administrator = 10,
    Support = 11
}